<template>
  <div>
    <b-custom-spinner :is_progress="is_progress"></b-custom-spinner>

    <b-row>
      <b-col>
        <b-card no-body>
          <b-card-header class="d-block">
            <b-card-title>
              {{ lang("t_announcements") }}
            </b-card-title>
            <!-- <b-card-sub-title class="mt-1">
              {{ lang("t_announcements") }}
            </b-card-sub-title> -->
          </b-card-header>

          <b-card-body class="px-0">
            <b-card-text class="d-flex mx-2">
              <b-input-group class="input-group-merge">
                <b-input-group-prepend is-text>
                  <feather-icon icon="SearchIcon" />
                </b-input-group-prepend>

                <b-form-input
                  v-model="searchQuery"
                  :placeholder="lang('t_search')"
                ></b-form-input>
              </b-input-group>

              <b-button
                @click="
                  modal_record_details = true;
                  isEdit = false;
                  reset_record();
                "
                size="sm"
                class="px-50 py-50 ml-2"
                variant="flat-secondary"
              >
                <b-icon icon="plus"></b-icon>
              </b-button>
              <b-button size="sm" class="px-50 py-50" variant="flat-secondary">
                <b-icon icon="funnel"></b-icon>
              </b-button>
            </b-card-text>
            <b-table
              :filter="searchQuery"
              small
              hover
              :fields="tableColumns"
              :items="records"
              responsive
              show-empty
              :empty-text="lang('t_noRecord')"
              :busy="records.length == 0"
              :per-page="perPage"
              :current-page="currentPage"
            >
              <template #empty="scope">
                <b-container class="mt-5">
                  <b-row>
                    <b-col class="text-center text-muted mt-50">
                      <span>{{ scope.emptyText }}</span>
                    </b-col>
                  </b-row>
                </b-container>
              </template>
              <template #cell(creator)="data">
                <b-avatar class="mr-1" variant="light-secondary">
                  {{
                    `${data.value
                      .split("@")[0]
                      .split(".")[0][0]
                      .toUpperCase()}${data.value
                      .split("@")[0]
                      .split(".")
                      [
                        data.value.split("@")[0].split(".").length - 1
                      ][0].toUpperCase()}`
                  }}
                </b-avatar>
                {{ data.value.split("@")[0] }}
              </template>
              <template #cell(is_hold_sound)="data">
                <feather-icon
                  :icon="data.value ? 'CheckIcon' : 'XIcon'"
                  size="12"
                  class="align-middle text-body"
                />
              </template>

              <!-- Column: Actions -->
              <template #cell(actions)="data">
                <b-dropdown
                  dropleft
                  boundary="viewport"
                  variant="link"
                  no-caret
                  :right="$store.state.appConfig.isRTL"
                >
                  <template #button-content>
                    <feather-icon
                      icon="MoreVerticalIcon"
                      size="16"
                      class="align-middle text-body"
                    />
                  </template>
                  <b-dropdown-item @click="playSound(data.item)">
                    <feather-icon icon="PlayIcon" />
                    <span class="align-middle ml-50"
                      >{{ lang("t_listen") }}
                    </span>
                  </b-dropdown-item>
                  <b-dropdown-item @click="showUsedAreas(data.item)">
                    <feather-icon icon="EyeIcon" />
                    <span class="align-middle ml-50"
                      >{{ lang("t_showUsedAreas") }}
                    </span>
                  </b-dropdown-item>
                  <b-dropdown-item @click="updateSelected(data.item)">
                    <feather-icon icon="EditIcon" />
                    <span class="align-middle ml-50">{{ lang("t_edit") }}</span>
                  </b-dropdown-item>

                  <b-dropdown-item @click="confirmText(data.item)">
                    <feather-icon icon="TrashIcon" />
                    <span class="align-middle ml-50">{{
                      lang("t_delete")
                    }}</span>
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
          </b-card-body>

          <b-card-footer class="py-75 border-0">
            <div
              class="d-flex justify-content-between d-flex align-items-center"
            >
              <div class="d-flex align-items-center mb-0">
                <!-- <span class="text-nowrap"> Showing 1 to </span> -->
                <b-form-select
                  size="sm"
                  v-model="perPage"
                  :options="['10', '25', '50']"
                  class="mr-1"
                  @input="
                    (value) => props.perPageChanged({ currentPerPage: value })
                  "
                />
                <span class="text-nowrap text-muted font-small-3">
                  {{
                    lang("t_total") +
                    " " +
                    records.length +
                    " " +
                    lang("t_row").toLowerCase()
                  }}
                </span>
              </div>

              <b-pagination
                size="sm"
                class="mb-0"
                v-model="currentPage"
                :per-page="perPage"
                align="right"
                :total-rows="records.length"
                first-number
                last-number
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="16" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="16" />
                </template>
              </b-pagination>
            </div>
          </b-card-footer>
        </b-card>
      </b-col>
    </b-row>

    <b-modal
      no-close-on-esc
      no-close-on-backdrop
      :title="isEdit ? lang('t_edit') : lang('t_add')"
      centered
      v-model="modal_record_details"
      :ok-title="lang('t_save')"
      :cancel-title="lang('t_cancel')"
      @ok="add_record"
    >
      <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
        <!-- Form -->
        <b-form
          class="p-2"
          @submit.prevent="handleSubmit(onSubmit)"
          @reset.prevent="resetForm"
        >
          <b-form-checkbox
            v-if="isEdit == false"
            class="mb-1"
            v-model="currentData.tts"
            switch
            inline
          >
            {{ lang("t_tts") }}
          </b-form-checkbox>
          <!-- Name -->
          <validation-provider
            #default="validationContext"
            name="announcementName"
            rules="required"
          >
            <b-form-group
              :label="lang('t_announcementName')"
              label-for="announcementName"
            >
              <b-form-input
                id="announcementName"
                v-model="currentData.display_name"
                :state="getValidationState(validationContext)"
                trim
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          <div v-if="isEdit == false">
            <b-form-group
              v-if="currentData.tts"
              :label="lang('t_provider')"
              label-for="provider"
            >
              <v-select
                v-model="currentData.provider"
                :options="tts_providers"
                :placeholder="lang('t_provider')"
                :reduce="(val) => val"
                label="display_name"
                value="internal_name"
              ></v-select>
            </b-form-group>
            <!-- <b-form-group
              v-if="currentData.tts && currentData.provider"
              :label="lang('t_speaker')"
              label-for="speaker"
            >
              <v-select
                v-model="currentData.speaker"
                :options="
                  speaker_list.filter(
                    (e) => e.type == currentData.provider.type
                  )
                "
                :placeholder="lang('t_speaker')"
                :reduce="(val) => val.internal_name"
                label="display_name"
                value="internal_name"
              ></v-select>
            </b-form-group> -->
            <b-form-group
              v-if="currentData.tts"
              :label="lang('t_text')"
              label-for="text"
            >
              <b-form-textarea
                rows="5"
                id="text"
                v-model="currentData.text"
                trim
              />
            </b-form-group>

            <!-- Surname -->
            <b-form-group
              v-if="!currentData.tts"
              :label="lang('t_selectAudioFile')"
              label-for="announcementName"
            >
              <b-form-file
                v-model="files"
                :placeholder="lang('t_selectAudioFile')"
                drop-placeholder="Dosya yükle..."
                accept=".wav, .mp3, .gsm"
                no-drop
              />
            </b-form-group>

            <b-form-checkbox
              v-if="!currentData.tts"
              v-model="currentData.is_hold_sound"
              class="custom-control-primary mb-1"
            >
              <span class="vs-checkbox">
                <span class="vs-checkbox--check">
                  <!-- <i class="vs-icon feather icon-check" /> -->
                  {{ lang("t_isHoldSound") }}
                </span>
              </span>
            </b-form-checkbox>

            <span class="text-muted"
              >Format: Mono 8000 Rate, 16-bit Signed Integer PCM & .wav
            </span>
          </div>

          <!-- Form Actions
          <div class="d-flex mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2"
              type="submit"
            >
               {{lang('t_add')}}
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-secondary"
              @click="hide"
            >
              {{lang('t_cancel')}}
            </b-button>
          </div>
          -->
        </b-form>
      </validation-observer>
    </b-modal>
    <b-modal
      no-close-on-esc
      no-close-on-backdrop
      ok-only
      :ok-title="lang('t_close')"
      :title="currentData.display_name"
      centered
      v-model="modal_play_sound"
    >
      <div class="my-2" v-html="htmlcontent"></div>
    </b-modal>
  </div>
</template>

<script>
import {
  BFormTextarea,
  BForm,
  BFormGroup,
  BFormInvalidFeedback,
  BFormCheckbox,
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BModal,
  BFormFile,
  BCardFooter,
  BCardBody,
  BCardHeader,
  BCardTitle,
  BCardSubTitle,
  BFormSelect,
  BInputGroupPrepend,
  BInputGroup,
  BCardText,
} from "bootstrap-vue";
import vSelect from "vue-select";
import store from "@/store";
import { ref, onUnmounted } from "@vue/composition-api";
import { avatarText } from "@core/utils/filter";
import useList from "./useList";
import storeModule from "../storeModule";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, alphaNum, email, password } from "@validations";
import formValidation from "@core/comp-functions/forms/form-validation";

import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    BFormTextarea,
    BForm,
    BFormGroup,
    BFormInvalidFeedback,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    BModal,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BFormFile,
    vSelect,
    BCardFooter,
    BCardBody,
    BCardHeader,
    BCardTitle,
    BCardSubTitle,
    BFormSelect,
    BInputGroupPrepend,
    BInputGroup,
    BCardText,
  },
  data() {
    return {
      lang: _l(window.localStorage.getItem("language") || "tr"),
      is_progress: false,
      isEdit: false,
      records: [],
      tts_providers: [],
      currentData: {
        tts: false,
        text: "",
        provider: null,
        speaker: "",
        internal_name: "",
        display_name: "",
        duration: 0,
        is_hold_sound: false,
      },
      files: null,
      modal_record_details: false,
      required,
      alphaNum,
      email,
      password,
      tableColumns: [
        { key: "creator", label: globalThis._lang("t_user"), sortable: true },
        {
          key: "display_name",
          label: globalThis._lang("t_announcementName"),
          sortable: true,
        },
        {
          key: "is_hold_sound",
          label: globalThis._lang("t_isHoldSound"),
          sortable: true,
        },
        {
          key: "actions",
          label: '',
          sortable: false,
          thStyle: { width: '5vh' }
        },
      ],
      speaker_list: [
        { type: "Callexper", internal_name: "anna", display_name: "Kadın1" },
        { type: "Callexper", internal_name: "ahmet", display_name: "Kadın2" },
        {
          type: "Callexper",
          internal_name: "incilafull",
          display_name: "Erkek1",
        },
      ],
      modal_play_sound: false,
      htmlcontent: "",
    };
  },
  computed: {
    items() {
      const start = (this.currentPage - 1) * this.perPage;
      const end = this.currentPage * this.perPage;
      return this.records.slice(start, end);
    },

  },
  mounted: function () {
    this.get_records();
    this.get_tts_providers();
  },
  methods: {
    async showUsedAreas(item) {
      var response = (await this.$http_in.get(`smgr/v1/AnnouncementAreas/${item.internal_name}`)).data;
      this.$swal({
        title: globalThis._lang('t_showUsedAreas'),
        width: 800,
        html: '<pre style="text-align:left">' + JSON.stringify(response, ' ', 2) + '</pre>',
        icon: "info",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
    flattenObject(ob) {
      var toReturn = {};
      if (Array.isArray(ob)) {
        toReturn['length'] = ob.length
      }

      for (var i in ob) {
        if (!ob.hasOwnProperty(i)) continue;

        if ((typeof ob[i]) == 'object' && ob[i] !== null) {
          var flatObject = this.flattenObject(ob[i]);
          for (var x in flatObject) {
            if (!flatObject.hasOwnProperty(x)) continue;

            toReturn[i + '.' + x] = flatObject[x];
          }
        } else {
          toReturn[i] = ob[i];
        }
      }
      return toReturn;
    },
    get_tts_providers: async function () {
      var response = (await this.$http_in.get(`spv/v1/TTSProvider`)).data;
      console.log("TTSProvider", response);
      this.tts_providers = response;
    },
    playSound(item) {
      this.currentData = item;
      this.modal_play_sound = true;

      console.log("aaa", item);
      let path =
        `${globalThis.env["PROTOCOL"]}://${globalThis.env.SOUND_URL}/sounds/` +
        item.internal_name +
        ".wav";

      this.htmlcontent = `<audio id="voyce_audio" ref="player" controls preload="none" style = "width:100%">
                <source src="${path}" type="audio/mpeg">
                Your browser does not support the audio element.
              </audio>`;
    },
    get_records: async function () {
      this.is_progress = true;
      var response = (await this.$http_in.get(`smgr/v1/Announcement`)).data;
      console.log("Announcement", response);
      this.records = response;
      this.is_progress = false;
    },
    check_data() {
      if (this.currentData.display_name == "") {
        return true;
      }
      return false;
    },
    add_record: async function () {
      if (this.check_data()) {
        this.$swal({
          title: globalThis._lang("t_warning"),
          text: globalThis._lang("t_pleaseDoNotLeaveAnyBlankFields"),
          icon: "warning",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          buttonsStyling: false,
        });
        return;
      }
      this.is_progress = true;
      var response;
      if (!this.isEdit) {
        let formData = new FormData();
        if (!this.currentData.tts) {
          formData.append("files", this.files, this.currentData.display_name);
        }
        formData.append("current_data", this.currentData.display_name);
        formData.append("provider", JSON.stringify(this.currentData.provider));
        formData.append("tts", this.currentData.tts);
        formData.append("speaker", this.currentData.speaker);
        formData.append("text", this.currentData.text);
        formData.append("is_hold_sound", this.currentData.is_hold_sound);
        response = (
          await this.$http_in.post(`smgr/v1/Announcement`, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
        ).data;
      } else {
        response = (
          await this.$http_in.put(`smgr/v1/Announcement`, {
            data: JSON.stringify(this.currentData),
          })
        ).data;
      }
      this.is_progress = false;
      if (response && response.acknowledged) {
        this.$swal({
          title: globalThis._lang("t_processSuccess"),
          text: globalThis._lang("t_hasBeenCreatedSuccessfully"),
          icon: "success",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          buttonsStyling: false,
        });
      } else {
        this.$swal({
          title: globalThis._lang("t_error"),
          text: globalThis._lang("t_AProblemOccurredwhileProcessing"),
          icon: "error",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          buttonsStyling: false,
        });
      }

      this.reset_record();
      this.get_records();
    },
    delete_record: async function () {
      try {
        this.is_progress = true;
        var response = (
          await this.$http_in.delete(
            `smgr/v1/Announcement/${this.currentData.internal_name}`
          )
        ).data;
        this.is_progress = false;

        if (response && response.acknowledged) {
          this.$swal({
            icon: "success",
            title: this.lang("t_processSuccess"),
            text: this.lang("t_customersHaveBeenSuccessfullyDeleted"),
            confirmButtonText: this.lang("t_ok"),
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
      }
      catch (error) {
        if (error && error.response && error.response.data) {
          this.$swal({
            title: globalThis._lang("t_error"),
            text: `${error.response.data} kullanıldığı için kayıt silinemiyor.`,
            icon: "error",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            buttonsStyling: false,
          });
        }
      } finally {
        this.is_progress = false;
      }

      this.reset_record();
      this.get_records();
    },
    reset_record() {
      this.isEdit = false;
      this.currentData = {
        tts: false,
        text: "",
        provider: null,
        speaker: "",
        internal_name: "",
        display_name: "",
        duration: 0,
        is_hold_sound: false,
      };
      this.files = null;
    },
    updateSelected(item) {
      this.currentData = { ...item, tts: item.tts == 'true' ? true : false };
      console.log("item", item);
      this.isEdit = true;
      //this.isAddNewUserSidebarActive = true;
      this.modal_record_details = true;
    },
    confirmText(item) {
      this.currentData = item;
      this.$swal({
        title: this.lang("t_deleteRecord"),
        text: this.lang("t_areYouSureYouWantToDeleteTheSelectedRecord"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.lang("t_yes"),
        cancelButtonText: this.lang("t_cancel"),
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.delete_record();
        }
      });
    },
    deleteRecord: async function () {
      // Vue.$toast('Kayıt silme.');

      this.fetchData();
    },
  },
  setup() {
    const USER_APP_STORE_MODULE_NAME = "app-user";
    // const USER_APP_STORE_MODULE_NAME = 'app-user'
    const toast = Vue.$toast;

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME))
      store.registerModule(USER_APP_STORE_MODULE_NAME, storeModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME))
        store.unregisterModule(USER_APP_STORE_MODULE_NAME);
    });

    const blankUserData = {
      fullName: "",
      username: "",
      email: "",
      role: null,
      currentPlan: null,
      company: "",
      contact: "",
    };

    const resetuserData = () => {
      currentData.value = JSON.parse(JSON.stringify(blankUserData));
    };

    const { refFormObserver, getValidationState, resetForm } =
      formValidation(resetuserData);

    const isAddNewUserSidebarActive = ref(false);

    const extensOptions = [
      { label: "123", value: "123" },
      { label: "456", value: "456" },
      { label: "9999", value: "9999" },
      { label: "654", value: "654" },
    ];
    const projectOptions = [
      { label: "Abc", value: "1" },
      { label: "Proje2", value: "2" },
      { label: "Proje3", value: "3" },
      { label: "Proje4", value: "4" },
    ];
    const profileOptions = [
      { label: "Admin", value: "1" },
      { label: "Profil2", value: "2" },
      { label: "Profil3", value: "3" },
      { label: "Profil4", value: "4" },
    ];

    const roleOptions = [
      { label: "Admin", value: "admin" },
      { label: "Author", value: "author" },
      { label: "Editor", value: "editor" },
      { label: "Maintainer", value: "maintainer" },
      { label: "Subscriber", value: "subscriber" },
    ];

    const planOptions = [
      { label: "Basic", value: "basic" },
      { label: "Company", value: "company" },
      { label: "Enterprise", value: "enterprise" },
      { label: "Team", value: "team" },
    ];

    const statusOptions = [
      { label: "Pending", value: "pending" },
      { label: "Active", value: "active" },
      { label: "Inactive", value: "inactive" },
    ];

    var {
      fetchData,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      // Extra Filters
      roleFilter,
      planFilter,
      statusFilter,
    } = useList();

    return {
      // Sidebar
      isAddNewUserSidebarActive,

      fetchData,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,

      // Filter
      avatarText,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      extensOptions,
      projectOptions,
      profileOptions,
      roleOptions,
      planOptions,
      statusOptions,

      // Extra Filters
      roleFilter,
      planFilter,
      statusFilter,

      toast,
      refFormObserver,
      getValidationState,
      resetForm,
    };
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
